import { effect } from '@preact/signals';

/**
 *
 * @param deps  | Function that returns a value of a Signal to watch
 * @param fn    | Function to call when the value of the Signal changes
 * @param fireImmediately | If true, fn is called on first effect run
 * @returns     | Function to stop watching the Signal
 */
export function reaction(
  deps: () => any,
  fn: (updatedSignalValue: any) => void,
  fireImmediately: boolean = false
): () => void {
  let isFirst = true;

  const wrappedEffect = effect(() => {
    const value = deps();
    const first = isFirst;
    isFirst = false;
    if (first && !fireImmediately) return;
    fn(value);
  });

  return () => {
    if (wrappedEffect) {
      wrappedEffect();
    }
  };
}
